export default __webpack_public_path__ + "static/media/box1_step1.fc89f767.png";